var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.969 6.594V4.25a3.281 3.281 0 116.562 0v2.344m2.344 3.281v1.875M5.656 6.594h8.438s.937 0 .937.937v6.563s0 .937-.937.937H5.656s-.937 0-.937-.937V7.53s0-.937.937-.937"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTS45NjkgNi41OTRWNC4yNWEzLjI4MSAzLjI4MSAwIDEgMSA2LjU2MiAwdjIuMzQ0bTIuMzQ0IDMuMjgxdjEuODc1TTUuNjU2IDYuNTk0aDguNDM4cy45MzcgMCAuOTM3LjkzN3Y2LjU2M3MwIC45MzctLjkzNy45MzdINS42NTZzLS45MzcgMC0uOTM3LS45MzdWNy41M3MwLS45MzcuOTM3LS45MzciLz48L3N2Zz4=";
export { SvgIconUnlock as ReactComponent };